import React from 'react';

import { ModuleProps } from '../../../types';
import SupportLayout from '../components/SupportLayout';
import { SupportView } from '../types';

const Support: React.FC<ModuleProps> = props => {
  return <SupportLayout {...props} view={SupportView.CATEGORY} />;
};

export default Support;
